import React from "react";
import {
  useGetTextMessagesQuery,
  useGetMembersQuery,
  useGetSuperChatsQuery,
} from "../../api/apiSlice";
import { TextMessagesList } from "./textMessages/textMessagesList";
import { SuperChatList } from "./superChats/superChatList";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { NewMembersList } from "./newMembers/newMemberList";
import { UnpublishAllView } from "./unpublishAll";

export const CommentatorsView = () => {
  const { data: textMessages = [] } = useGetTextMessagesQuery(null);
  const { data: members = [] } = useGetMembersQuery(null);
  const { data: superChats = [] } = useGetSuperChatsQuery(null);

  return (
    <div className="container bg-white py-2">
      <Tabs justify defaultActiveKey="questions">
        <Tab
          eventKey="questions"
          title={"Questions (" + textMessages.length + ")"}
        >
          <TextMessagesList />
        </Tab>
        <Tab eventKey="link-1" title={"SuperChats (" + superChats.length + ")"}>
          {" "}
          <SuperChatList />{" "}
        </Tab>
        <Tab eventKey="link-2" title={"New Members (" + members.length + ")"}>
          <NewMembersList />
        </Tab>
      </Tabs>
      <UnpublishAllView />
    </div>
  );
};
